import { useAtom } from "jotai";
import { ArrowLeft } from "lucide-react";
import { transactionDetailsViewAtom } from "../../../../../../../../app/store";

export const ObservationsBackButton = () => {
  const [view, setView] = useAtom(transactionDetailsViewAtom);

  if (view !== "observations") return null;

  return (
    <button
      type="button"
      onClick={() => setView("details")}
      aria-label="Voltar para os detalhes da transação"
      className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-gray02 text-black03 transition-colors hover:bg-gray01"
    >
      <ArrowLeft size={18} />
    </button>
  );
};
